import axios from "axios";
import { ClientJS } from 'clientjs';
import { authUrl } from "services/data/mainUrl";

export default class AuthService {
    
    fingerprint = ((new ClientJS()).getFingerprint() << 32) >> 32;
    
    doPostRequest = async (url, data) => {

        const config = {
            withCredentials: true,
            headers: {
                'Content-Type': 'application/json'
            }
        }

        const response = await axios.post(
            `${authUrl}${url}`,
            {...data, fingerprint: this.fingerprint},
            config                
        )

        return response.data;
    };

    registerUser = (user) => {
        return this.doPostRequest(`/reg/`, user);
    };

    loginUser = (user) => {
         return this.doPostRequest(`/login/`, user);
    };

    refreshToken = () => { 
        return this.doPostRequest(`/refresh/`, {fingerprint: this.fingerprint});
    };
};